<template>
    <div>
        <div id="invoicepdf" class="container invoice bg-logo">
            <div class="invoice-header">
                <div class="row">
                    <div class="col-xs-8 left">
                        <h1>Invoice</h1>
                        <h4 class="text-muted">2021-001-E</h4>
                    </div>
                    <div class="col-xs-4">
                        <div class="media mg-left">
                            <div class="media-left">
                                <img class="media-object logo" src="../assets/static/images/logo/logo_expar.png" />
                            </div>
                            <ul class="media-body list-unstyled">
                                <li><strong>HRIBERŠEK, Mitja Krajnc s.p.</strong></li>
                                <li>Šmartno v Rožni dolini 21A,</li>
                                <li>SI-3201 Šmartno v Rožni dolini, Celje</li>
                                <li>Slovenia</li>
                                <li>VAT no.: 92189407</li>
                                <li>Reg. no: 8564914000</li>
                                <li>accounts@expar-store.com</li>
                                <br />
                                <br />
                                <li>Issue date:</li>
                                <h4 class="text-muted">01/01/2015</h4>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="invoice-body">
                <div class="row">
                    <div class="col-xs-7">
                        <div class="panel panel-default left">
                            <div class="panel-heading">
                                <h3 class="panel-title">Customer Details</h3>
                            </div>
                            <div class="panel-body">
                                <div>
                                    <dd>client.company.name</dd>
                                    <dd>client.company.address</dd>
                                    <dd>client.company.postal_code client.company.city</dd>
                                    <dd>client.company.country</dd>
                                    <dd>client.company.vat_no</dd>
                                    <!-- <dd>client.company.contact_email</dd> -->
                                    <!-- <dt>&nbsp;</dt>
                                    <dd>&nbsp;</dd> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default fullWidth">
                        <div class="panel-heading left">
                            <h3 class="panel-title">Services</h3>
                        </div>
                        <table class="table table-bordered table-condensed">
                            <thead>
                                <tr>
                                    <th class="text-left">Description</th>
                                    <th class="text-center colfix">Qty</th>
                                    <th class="text-center colfix">Unit price</th>
                                    <th class="text-center colfix">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-left"> 
                                    Premium plan
                                        <br>
                                        <small class="text-muted">Period: oct 21 - nov 21, 2021</small>
                                    </td>
                                    <td class="text-right">
                                        <span class="mono">2</span>
                                    </td>
                                    <td class="text-right">
                                        <span class="mono">12.00 €</span>
                                    </td>
                                    <td class="text-right">
                                        <span class="mono">24.00 €</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="panel fullWidth">
                        <table class="tableRight table-bordered table-condensed">
                            <tbody>
                                <tr>
                                    <th class="text-center col-xs-1">Subtotal</th>
                                    <th class="text-right col-xs-1">24.00 €</th>
                                </tr>
                                <tr>
                                    <th class="text-center col-xs-1">Discount</th>
                                    <th class="text-right col-xs-1">- €</th>
                                </tr>
                                <tr>
                                <tr>
                                    <th class="text-center col-xs-1">VAT (22%)</th>
                                    <th class="text-right col-xs-1">5.28 €</th>
                                </tr>
                                <tr>
                                    <th class="text-center rowtotal mono">TOTAL</th>
                                    <th class="text-right rowtotal mono">29.28 €</th>
                                    <!-- <th class="text-center rowtotal mono">5.28</th>
                                    <th class="text-center rowtotal mono">29.28</th> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-7">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <i>Comments / Notes</i>
                                <hr style="margin:3px 0 5px" /> 
                                <p>Total ammount <strong>PAID</strong> to DE04 1001 1001 2622 4346 09 (BIC: NTSBDEB1XXX) on <strong>21/10/2021</strong>.</p>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <div class="col-xs-5">
                        <div class="panel panel-default">
                            <br/>
                            <div class="panel-heading left">
                                <h3 class="panel-title">Payment Method</h3>
                            </div>
                            <div class="panel-body left">
                                <ul class="list-unstyled">
                                    <li>Credit/Debit card - <span class="mono"> DE00 0000 0000 0000 0000 00 </span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="invoice-footer">Thank you for choosing our services.
                <br/> If you have any questions concerning this invoice, please email to <strong>accounts@expar-store.com</strong>
                <br/>
            </div>
            <p class="logo-text">expar</p>
        </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
    mounted() {
        this.makePDF()
    },
    methods: {
        makePDF() {
            window.html2canvas = html2canvas
            var doc = new jsPDF('p', 'pt', 'a4')
            doc.html(document.querySelector('#invoicepdf'), {
                callback: function(pdf) {
                    pdf.save('invoice.pdf')
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>

body{
//   background:#EEE;
  /* font-size:0.9em !important; */
}

.mg-left {
    margin-left: 330px;
}

.left {
    text-align: left;
}
.fullWidth {
width: 100%;
}
.tableRight {
float: right;
width: 250px;
}

.logo-text {
    font-family: "Nasalization", Helvetica, Arial;  
    color: var(--bg);
    font-size: 2.5em;
    letter-spacing: 3px,
}

.bg-logo {
  background: url('../assets/static/images/logo/icon_expar_bright.png');
  background-repeat: repeat-y repeat-x;
  background-position: center;
  background-size: cover;
  height: 100%;
  width: 60%;
  margin: auto;
  z-index: -1;
}

.invoice{
  width:970px !important;
  margin:50px auto;
  .invoice-header{
    padding:25px 25px 15px;
    h1{
      margin:0
    }
    .media{
      .media-body{
        font-size:.9em;
        margin:0;
      }
    }
  }
  .invoice-body{
    border-radius:10px;
    padding:25px;
    // background:#FFF;
  }
  .invoice-footer{
    padding:15px;
    font-size:0.9em;
    text-align:center;
    color:#999;
  }
}
.logo{
  max-height:70px;
  border-radius:10px;
}
.dl-horizontal{
  margin:0;
  dt{
        float: left;
    width: 80px;
    overflow: hidden;
    clear: left;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  dd{
    margin-left:90px;
  }
}
.rowamount{
  padding-top:15px !important;
}
.rowtotal{
  font-size:1.3em;
}
.colfix{
  width:12%;
}
.mono{
  font-family:monospace;
}


</style>